import React, { useEffect, useRef } from "react";
import Hls from "hls.js";

const HomeBGVideoPlayer = ({
  videoSrc,
  type = "hls", // 'mp4', 'hls', 'm3u8', 'mpd'
  fullScreen = true,
  shouldShowBGVideo = true,
  handleFinished,
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    let hls;

    if (!shouldShowBGVideo || !videoSrc) return;

    // Handle HLS / m3u8 playback
    if ((type === "hls" || type === "m3u8") && Hls.isSupported()) {
      hls = new Hls({
        enableWorker: true,
        autoStartLoad: true,
      });
      hls.loadSource(videoSrc);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.muted = true; // required for autoplay
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch((err) => {
            console.warn("Autoplay failed:", err);
          });
        }
      });
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      // Safari native HLS
      video.src = videoSrc;
      video.muted = true;
      video.play().catch((err) => console.warn("Autoplay failed:", err));
    } else if (type === "mp4") {
      video.src = videoSrc;
      video.muted = true;
      video.play().catch((err) => console.warn("Autoplay failed:", err));
    }

    // Video end callback
    video.onended = () => {
      if (handleFinished) handleFinished();
    };

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [videoSrc, type, shouldShowBGVideo, handleFinished]);

  if (!shouldShowBGVideo) return null;

  return (
    <video
      ref={videoRef}
      playsInline
      autoPlay
      muted
      loop
      style={{
        position: fullScreen ? "fixed" : "relative",
        top: 0,
        left: 0,
        width: fullScreen ? "100vw" : "100%",
        height: fullScreen ? "100vh" : "100%",
        objectFit: "cover",
        // zIndex: -1,
      }}
    />
  );
};

export default HomeBGVideoPlayer;
